class LazyloadSection extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.renderOnLoad) {
      this.renderSection();
    } else {
      this.addEvents();
    }
  }

  addEvents() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.renderSection();
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '1000px', 
    });

    observer.observe(this);
  }

  renderSection() {
    var sectionSelector = '[id^=shopify-section]';
    const sectionId = this.closest(sectionSelector)?.id?.split('shopify-section-')[1] || null;
    if (!sectionId) return;

    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        if (this.dataset.selectors) {
          const selectors = JSON.parse(this.dataset.selectors);
          selectors.forEach(selector => {
            const sections = doc.querySelectorAll(selector);
            const sectionsToUpdate = this.querySelectorAll(selector);
            sections.forEach((section, index) => {
              const sectionHtml = section.innerHTML;
              $(sectionsToUpdate[index]).html(sectionHtml);
            });
          });
        } else {
          const section = this.dataset.selector ? doc.querySelector(this.dataset.selector) : doc.querySelector(sectionSelector)
          const sectionHtml = this.dataset.selector ? section.outerHTML : section.innerHTML;
          $(this).html(sectionHtml);
        }
        if (this.dataset.callback) {
          eval(this.dataset.callback);
        }
      })
  }
}

customElements.define('lazyload-section', LazyloadSection);
